"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _RequiredOnboardingSubtext = _interopRequireDefault(require("../calculator/RequiredOnboardingSubtext"));

var SuiteCalcRequiredOnboardingSectionContainer = function SuiteCalcRequiredOnboardingSectionContainer(_ref) {
  var shouldShowOnboardingSubtext = _ref.shouldShowOnboardingSubtext,
      billingNameKey = _ref.billingNameKey,
      activeCurrency = _ref.activeCurrency,
      pricingInfo = _ref.pricingInfo;

  if (!shouldShowOnboardingSubtext || !pricingInfo || !activeCurrency) {
    return null;
  }

  return _react.default.createElement(_RequiredOnboardingSubtext.default, {
    billingNameKey: billingNameKey,
    pricingInfo: pricingInfo,
    currencyCode: activeCurrency
  });
};

SuiteCalcRequiredOnboardingSectionContainer.propTypes = {
  shouldShowOnboardingSubtext: _propTypes.default.bool,
  billingNameKey: _propTypes.default.string.isRequired,
  activeCurrency: _propTypes.default.string,
  pricingInfo: _propTypes.default.object
};
var _default = SuiteCalcRequiredOnboardingSectionContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcRequiredOnboardingSectionContainer.js
// module id = 865
// module chunks = 5 6